import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgArrowSortOutline = function SvgArrowSortOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7374 3.76257C17.054 3.07914 15.946 3.07914 15.2626 3.76257C15.2626 3.76257 15.2626 3.76258 15.2625 3.76259L11.9697 7.05546C11.6768 7.34835 11.6768 7.82322 11.9697 8.11612C12.2626 8.40901 12.7374 8.40901 13.0303 8.11612L15.75 5.39646V20.5857C15.75 21 16.0858 21.3357 16.5 21.3357C16.9142 21.3357 17.25 21 17.25 20.5857V5.39646L19.9697 8.11612C20.2626 8.40901 20.7374 8.40901 21.0303 8.11612C21.3232 7.82322 21.3232 7.34835 21.0303 7.05546L17.7375 3.76259C17.7374 3.76258 17.7374 3.76257 17.7374 3.76257ZM7 3.33579C7.41421 3.33579 7.75 3.67157 7.75 4.08579V19.2751L10.4697 16.5554C10.7626 16.2625 11.2374 16.2625 11.5303 16.5554C11.8232 16.8483 11.8232 17.3232 11.5303 17.6161L8.23749 20.9089C7.55405 21.5925 6.44595 21.5925 5.76251 20.9089L2.46967 17.6161C2.17678 17.3232 2.17678 16.8483 2.46967 16.5554C2.76256 16.2625 3.23744 16.2625 3.53033 16.5554L6.25 19.2751V4.08579C6.25 3.67157 6.58579 3.33579 7 3.33579Z"
  })));
};

export { SvgArrowSortOutline as ReactComponent };
//# sourceMappingURL=arrow--sort-outline.svg.js.map
